import { IUnitNodePermissionCompanyGroupPermission, UnitNodePermissionCompanyGroupPermission } from "./unitNodePermissionCompanyGroupPermission";

export interface IUnitNodeGetChildPermissionsResult {
    permissions: { [id: string]: IUnitNodePermissionCompanyGroupPermission; };
}

export class UnitNodeGetChildPermissionsResult implements IUnitNodeGetChildPermissionsResult {
    permissions: { [id: string]: UnitNodePermissionCompanyGroupPermission; };

    /* eslint-disable no-prototype-builtins */
    constructor();
    constructor(obj: IUnitNodeGetChildPermissionsResult);
    constructor(obj?: any) {
        this.permissions = {};
        if (obj && obj.permissions) {
            for (const key in obj.permissions) {
                if (obj.hasOwnProperty(key)) {
                    this.permissions[key] = new UnitNodePermissionCompanyGroupPermission(obj.permissions[key]);
                }
            }
        }
    }
    /* eslint-enable no-prototype-builtins */
}